import "./Fleet.module.css";
import Header from "@/reusable_sections/Header";
import VehicleGallery from "./sections/VehicleGallery";
import VehicleFeatures from "./sections/VehicleFeatures";
import BookAVehicle from "./sections/BookAVehicle";
import Footer from "@/reusable_sections/Footer";
export default function FleetPage() {
  return <div>
      <Header />
      <VehicleGallery />
      <VehicleFeatures />
      <BookAVehicle />
      <Footer />
    </div>;
}